/********************************************************************
 * Copyright (c) Certus Software, 2022.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {Injectable} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {HttpClient} from '@angular/common/http';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private translate: TranslateService,
    private metaTagService: Meta,
    private liveAnnouncer: LiveAnnouncer,
    private titleService: Title,
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  setTitleAndDescription (titleKey, descKey) {
    this.translate.get([titleKey, descKey]).subscribe( (data: string) => {
      this.titleService.setTitle(data[titleKey] + ' | veglegestorles.hu');
      this.metaTagService.updateTag({
        name: 'description',
        content: data[descKey]
      });
      document.getElementById('pgStart').innerHTML = data[titleKey] + ' | veglegestorles.hu';
    });
  }

  checkForNotifications () {
    return this.apiService.getAppResource('/download/products/cecewm/notifications.json', {});
  }
}
